<template>
  <div>
    <b-card>
      <b-row>
        <b-col cols="12" md="4">
          <div class="card mb-0">
            <div class="card-header card-header-text card-header-primary">
              <div class="card-text">
                <h4 class="card-title">Status</h4>
              </div>
            </div>
            <div class="card-body">
              <b-dropdown left :text="$t('selectAction')">
                <b-dropdown-item
                    v-if="order.order_status === 'pending'"
                    @click="updateStatus('order','posted')">Bestellung senden
                </b-dropdown-item>
                <b-dropdown-item
                    v-if="order.order_status === 'return_request'"
                    @click="updateStatus('order','return_accept')">Rückgabeauftrag
                  annehmen
                </b-dropdown-item>
                <b-dropdown-item
                    v-if="order.order_status === 'cancel'"
                    @click="updateStatus('order','payingMoney')">Auftragsstornierung
                  bestätigen
                </b-dropdown-item>
                <b-dropdown-item
                    v-if="order.order_status !== 'cancel' && order.order_type_payment === 'vorkasse' && order.order_send_email_type_status !== 'acceptVorkasse'"
                    @click="updateStatus('order','acceptVorkasse')">Zahlungseingang
                  Vorkasse
                </b-dropdown-item>
                <b-dropdown-item
                    v-if="(order.order_type_payment === 'eps' || order.order_type_payment === 'card' || order.order_type_payment === 'giropay') && order.order_send_email_type_status !== 'acceptPayment'"
                    @click="updateStatus('order','acceptPayment')">Zahlungseingang /
                  Versand
                </b-dropdown-item>
                <b-dropdown-item
                    v-if="order.order_type_transport === '8' && order.order_send_email_inperson !== 'yes'"
                    @click="updateStatus('order','inPerson')">Zahlungseingang /
                  Abholer
                </b-dropdown-item>
                <b-dropdown-item
                    v-if="order.order_type_payment === 'purhcaseoninvoice' && order.order_send_email_purchaseinvoice !== 'yes'"
                    @click="updateStatus('order','purhcaseoninvoice')">Zahlungseingang Rechnung
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </b-col>
        <!--Status-->
        <b-col cols="12" md="4">
          <div class="card mb-0">
            <div class="card-header card-header-text card-header-primary">
              <div class="card-text">
                <h4 class="card-title">Erinnerung</h4>
              </div>
            </div>
            <div class="card-body">
              <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                                <span>
                                    <span class="font-weight-bold">Erinnerung 1: </span>
                                    <br>
                                    <span>{{ order.order_email_notice_date }}</span>
                                </span>
                  <span>
                                    <span class="font-weight-bold">Erinnerung 2: </span>
                                            <br>
                                    <span>{{ order.order_email_notice_date2 }}</span>
                                </span>
                </b-list-group-item>
              </b-list-group>

              <b-dropdown left :text="$t('selectAction')">
                <b-dropdown-item
                    v-if="order.order_email_notice === 0"
                    @click="updateStatus('orderNotPaid',1)">Erinnerung 1
                </b-dropdown-item>
                <b-dropdown-item @click="updateStatus('orderNotPaid',2)">Erinnerung 2
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </b-col>
        <!--Remember Dates-->
        <b-col cols="12" md="4">
          <div class="card mb-0">
            <div class="card-header card-header-text card-header-primary">
              <div class="card-text">
                <h4 class="card-title">Coin.de / RAW</h4>
              </div>
            </div>
            <div class="card-body">
              <p>{{ $t('dateTitle') }}: <span class="font-weight-bold">{{ orderPaymentPaidDate }}</span></p>

              <b-form-group
                  class="font-weight-bold"
                  label="SELECT PAYMENT DATE">
                <date-picker
                    format="YYYY-MM-DD"
                    display-format="YYYY-MM-DD"
                    @change="updatePaymentDate"
                    locale="en" v-model="paidDate"></date-picker>
              </b-form-group>
            </div>
          </div>
        </b-col>
        <!--Payment Date-->
      </b-row>


      <b-button
          :variant="order.order_status === 'posted' || order.order_status === 'reviewed' ? 'success' : 'light'">
        Bestellung senden
      </b-button>

      <template v-if="order.order_status === 'return_request' || order.order_status === 'return_accept'">
        <b-button :variant="order.order_status === 'return_accept' ? 'success' : 'light'">
          Rückgabeauftrag annehmen
        </b-button>
      </template>

      <template v-if="order.order_type_payment === 'purhcaseoninvoice'">
        <b-button :variant="order.order_send_email_purchaseinvoice === 'yes' ? 'success' : 'light'">
          Zahlungseingang Rechnung
        </b-button>
      </template>

      <template v-if="order.order_send_email_type_status === 'payingMoney'">
        <b-button variant="success">
          Auftragsstornierung bestätigen
        </b-button>
      </template>

      <template v-if="order.order_send_email_type_status === 'acceptVorkasse'">
        <b-button variant="success">
          Zahlungseingang Vorkasse
        </b-button>
      </template>

      <template
          v-if="(order.order_type_payment === 'eps' || order.order_type_payment === 'card' || order.order_type_payment === 'giropay') && order.order_send_email_type_status === 'acceptPayment'">
        <b-button variant="success">
          Zahlungseingang / Versand
        </b-button>
      </template>

      <template v-if="order.order_send_email_inperson === 'yes'">
        <b-button variant="success">
          Zahlungseingang / Abholer
        </b-button>
      </template>

    </b-card>
  </div>
</template>

<script>
import Http from '../../../Services/HttpService/HttpService'
import Notification from '../../../Services/Notification/Nottification'
import {EventBus} from "../../../Services/Eventbus/event-bus";

export default {
  name: "Buttons",
  props: {
    order: {
      type: Object,
      default: null
    },
    orderPaymentPaidDate: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      paidDate: null
    }
  },
  methods: {
    updateStatus(myType, myValue) {
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'order/update/' + this.$route.params.orderid, {
        type: myType,
        status: myValue,
      })
          .then(response => {
            if (response.data.status_code === Http.ok()) {
              this.$Progress.finish();
              Notification.success(response.data.message);
              EventBus.$emit('updateLog', 'yes')
            } else {
              Notification.error(response.data.message);
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    updatePaymentDate() {
      if (confirm(this.$t('alertText'))) {
        this.$Progress.start();
        Http.post(Http.apiurlV2() + 'order/update/paymentDate/' + this.$route.params.orderid, {
          paymentPaidDate: this.paidDate
        })
            .then(response => {
              if (response.data.status_code === Http.ok()) {
                this.$Progress.finish();
                this.paidDate = null;
                Notification.success(response.data.message);
                EventBus.$emit('updateLog', 'yes')
              } else {
                Notification.error(response.data.message);
              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }

    },
  }
}
</script>

<style scoped>

</style>